import {useSortableTable} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

import {StaticPartAreaSymbol, StaticPartSymbolGlyph} from './symbols'

import {StaticPartLayerTypes} from '@refra/modules/refra-static-parts/enums'

export interface StaticPartShutdownPrintRow {
  areaName: string
  color: string
  symbol?: StaticPartAreaSymbol
  layer: StaticPartLayerTypes
  material: string
  thickness: number | string
  weight: number | string
}

export const useStaticPartShutdownPrintTableConfig = () => {
  const {t} = useTranslation()

  return useSortableTable<StaticPartShutdownPrintRow>([
    {
      label: t('staticParts.report.area'),
      value: (row) => row.areaName
    },
    {
      label: t('staticParts.report.colorTag'),
      render: (row) => (
        <span
          className="inline-block h-5 w-10 rounded-full"
          style={{backgroundColor: row.color}}
          data-cy="static_part_shutdown_print_color_tag"
        />
      )
    },
    {
      label: t('staticParts.report.visualSymbol'),
      render: (row) => (row.symbol ? <StaticPartSymbolGlyph symbol={row.symbol} /> : null)
    },
    {
      label: t('staticParts.editReplacement.table.layer'),
      value: (row) => t(`staticParts.editReplacement.layers.${row.layer}`)
    },
    {
      label: t('staticParts.editReplacement.table.material'),
      value: (row) => row.material ?? '-'
    },
    {
      label: t('staticParts.editReplacement.table.thickness'),
      value: (row) => row.thickness ?? '-'
    },
    {
      label: t('staticParts.editReplacement.table.materialPlanned'),
      value: (row) => row.weight ?? '-'
    }
  ])
}
